<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconLowerhand_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M19.439 9.58c.192-.738.91-1.172 1.604-.967.694.203 1.102.968.91 1.705l-.681 2.615-.976 3.748-5.304-5.616 1.719-6.603c.192-.738.91-1.171 1.604-.967s1.1.968.91 1.706l-2.087 8.017 1.257.369zm-5.507.362 1.87-7.186c.193-.737-.215-1.5-.909-1.705s-1.412.229-1.604.966L11.81 7.696zm-3.776-1.086-.558 2.142 1.257.37.361-1.389 8.345 8.836c-.61 1.313-1.462 2.421-2.457 3.096-2.086 1.414-4.85 1.316-7.71.474-2.32-.683-7.105-3.068-7.319-8.228A116 116 0 0 1 2 10.186c-.003-.695.473-1.283 1.12-1.389.704-.115 1.367.384 1.5 1.127.22 1.244.532 2.977.633 3.44.127.597.87.595 1.023.006L8.035 6.61zm.594-2.283.934-3.591c.192-.738-.214-1.501-.908-1.706-.694-.204-1.413.229-1.604.967l-.543 2.085z"
        clip-rule="evenodd"
    />
    <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-width="2"
        d="m4.727 4.313 17 18"
    />
</svg>
